import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'

const setPostKudos = async ({ kudos, post }) => {
	try {
		const { postId } = post
		const uid = getCurrentUid()
		const ref = firestore.collection('posts').doc(postId).collection('kudos').doc(uid)
		if (kudos) {
			await ref.set({ uid, postId, createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
		} else {
			await ref.delete()
		}
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}

export default setPostKudos



// WEBPACK FOOTER //
// ./src/dataservices/setPostKudos.js